import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { DashboardPizzaRQ } from './model/DashboardPizzaRQ';
import { Observable } from 'rxjs';
import { DashboardPizzaRS } from './model/DashboardPizzaRS';
import { endpoints } from '../../../environments/endpoint';

const httpOptions = {
  headers: new HttpHeaders({
    'Content-Type':  'application/json'
  })
};

@Injectable({
  providedIn: 'root'
})

export class DashboardPizzaService {

  constructor(private http: HttpClient) { }

  convertDataIsoPizza(request: DashboardPizzaRQ): void {
    let arrayStringPizza: string[] = [];
    arrayStringPizza = request.dtVoo.split('/');
    request.dtVoo = arrayStringPizza[2]
                    + '-' +  arrayStringPizza[1]
                      + '-' +  arrayStringPizza[0]
                        + 'T00:00:00';
  }

  getDataByDate(requestPizza: DashboardPizzaRQ): Observable<DashboardPizzaRS[]> {
    if (!requestPizza.dtVoo.includes('T')) {
      this.convertDataIsoPizza(requestPizza);
    }
    let params1 = new HttpParams().set('flightBeginDate', requestPizza.dtVoo);
    return this.http.get<DashboardPizzaRS[]>(endpoints.REST_POST_RPE_NOT_GENERATE_GROUP_BY_SYS_ORI+"?"+params1, httpOptions);
  }
}
